/*!
 app.js
 */

/*global require, define, dna*/
require(['angular', 'ngCache', 'ngRoute', 'ngSanitize', 'ngUpload', 'angularLazyImg', 'angularI18n', 'ngAnimate', 'ngSVGAttributes'], function(angular, ngCache, ngRoute, ngSanitize, ngUpload, angularLazyImg, angularI18n, ngAnimate) {
    'use strict';

    // IE browsers cache ajax calls. Since Angular uses jQuery to make ajax calls, we can tell jQuery to turn off caching.
    $.ajaxSetup({
        cache: false
    });

    (function($) {

        /**
         * @function
         * @property {object} jQuery plugin which runs handler function once specified element is inserted into the DOM
         * @param {function} handler A function to execute at the time when the element is inserted
         * @param {bool} shouldRunHandlerOnce Optional: if true, handler is unbound after its first invocation
         * @param {bool} isChild
         * @example $(selector).waitUntilExists(function);
         */

        $.fn.waitUntilExists = function(handler, shouldRunHandlerOnce, isChild) {
            var found = 'found';
            var $this = $(this.selector);
            var $elements = $this.not(function() {
                return $(this).data(found);
            }).each(handler).data(found, true);

            if (!isChild) {
                (window.waitUntilExists_Intervals = window.waitUntilExists_Intervals || {})[this.selector] =
                        window.setInterval(function() {
                            $this.waitUntilExists(handler, shouldRunHandlerOnce, true);
                        }, 500);
            } else if (shouldRunHandlerOnce && $elements.length) {
                window.clearInterval(window.waitUntilExists_Intervals[this.selector]);
            }

            return $this;
        };

    }(jQuery));

    angular.module('dnaApp', ['angular-cache', 'ngRoute', 'ngSanitize', 'ngUpload', 'angularLazyImg', 'ngAnimate', 'ngSVGAttributes']);

    define('dnaApp', [
        'angular',
        'utils/cookies',
        'resolver',
        'text!core/controllers/Error-403.html',
        'text!core/controllers/Error-404.html',
        'text!core/partials/Error-503-serviceUnavailableContent.html',
        'text!core/controllers/ExternalRedirect.html',
        'text!insights/controllers/InsightsPage.html',
        'text!evidence/controllers/TreeEvidencePage.html',
        'text!testSettings/controllers/TestSettingsPage.html',
        'text!testSettings/controllers/LinkToTreePage.html',
        'text!testSettings/controllers/RawDownloadPage.html',
        'text!activation/controllers/InstitutionActivationPage.html',
        'text!tests/controllers/LegacyPage.html',
        'text!activation/controllers/RecollectPage.html',
        'text!matches/controllers/MatchesPage.html',
        'text!memberMatch/controllers/MemberMatchPage.html',
        'text!core/controllers/Tnc.html',
        'text!core/controllers/CmsPage.html',
        'text!memberMatch/controllers/MatchGone.html',
        'text!showAll/controllers/ShowAll.html',
        'text!core/controllers/Unsubscribe.html',
        'text!smgf/controllers/smgf.html',
        'text!subscribe/controllers/subscribePage.html',
        'text!engagement/controllers/engagementPage.html',
        'text!invitations/controllers/invitation.html',
        'text!maintenance/controllers/SiteMaintenancePage.html',
        'core/directives/focusDirective',
        'core/directives/onEnterDirective',
        'core/directives/dnaModalDirective',
        'core/directives/dnaCalloutDirective',
        'core/directives/dnaTncDirective',
        'core/directives/mboxDirective',
        // 'core/directives/dnaInitDirective',
        'core/directives/subHeaderDirective',
        'core/directives/dnaPlaceholderDirective',
        'core/directives/cmsSpotDirective',
        'core/filters/i18nFilter',
        'core/filters/imageFilter',
        'core/services/CmsService',
        'core/services/ConfigurationService',
        'core/services/TrackingService',
        'core/services/MixpanelService',
        'core/services/TestsService',
        'core/services/UtilService',
        'core/services/LoggingService',
        'core/factory/ErrorFactory',
        'core/factory/RedirectFactory',
        'core/factory/RetryFactory',
        'core/factory/TimingFactory',
        'core/factory/PerformanceMetricFactory',
        'core/factory/LazyLoadImageRefreshFactory'
    ], function(angular, Cookies, resolver, html_error403, html_error404, html_error503_defaultDirectiveContent, html_externalRedirect, html_insightsPage, html_treeEvidencePage, html_testSettingsPage, html_linkToTreePage, html_rawDownloadPage, html_instituteActivationPage, html_legacyPage, html_recollectPage, html_matchesPage, html_memberMatchPage, html_tncPage, html_cmsPage, html_matchGone, html_showAll, html_unSubscribe, html_smgf, html_subscribe, html_engagement, html_invitations, html_siteMaintenance) {
        var dnaApp = angular.module('dnaApp');
        dnaApp.config(['$controllerProvider', '$compileProvider', '$filterProvider', '$animateProvider', '$provide', '$routeProvider', '$httpProvider', '$logProvider', '$sceDelegateProvider', '$locationProvider', 'CacheFactoryProvider',
            function($controllerProvider, $compileProvider, $filterProvider, $animateProvider, $provide, $routeProvider, $httpProvider, $logProvider, $sceDelegateProvider, $locationProvider, CacheFactoryProvider) {
                dnaApp.lazy = {
                    controller: $controllerProvider.register,
                    directive: $compileProvider.directive,
                    filter: $filterProvider.register,
                    factory: $provide.factory,
                    service: $provide.service,
                    constant: $provide.constant,
                    animation: angular.bind($animateProvider, $animateProvider.register)
                };
                dnaApp.defineService = function(args) {
                    if (dnaApp.lazy.service) {
                        dnaApp.lazy.service.apply(dnaApp, args);
                    } else {
                        dnaApp.service.apply(dnaApp, args);
                    }
                };
                CacheFactoryProvider.defaults.deleteOnExpire = 'passive';
                if (dna.app.debugInfoEnabled != null) {
                    $compileProvider.debugInfoEnabled(dna.app.debugInfoEnabled);
                }
                $locationProvider.html5Mode(true);
                $routeProvider.when('/', {
                    redirectTo: function() {
                        return '/insights';
                    }
                });
                $routeProvider.when('/403', {
                    template: html_error403,
                    resolve: resolver(['core/controllers/ErrorController'])
                });
                $routeProvider.when('/tests', {
                    redirectTo: function () {
                        return '/insights';
                    }
                });
                $routeProvider.when('/insights/:testGuid?', {
                    template: html_insightsPage,
                    reloadOnSearch: false,
                    resolve: resolver(['insights/controllers/InsightsPageController'])
                });
                $routeProvider.when('/tests/:testGuid/evidence/:cadId', {
                    template: html_treeEvidencePage,
                    resolve: resolver(['evidence/controllers/TreeEvidencePageController'])
                });
                $routeProvider.when('/testSettings/:testGuid', {
                    template: html_testSettingsPage,
                    resolve: resolver(['testSettings/controllers/TestSettingsPageController'])
                });
                $routeProvider.when('/linkToTree/:testGuid', {
                    template: html_linkToTreePage,
                    resolve: resolver(['testSettings/controllers/LinkToTreePageController'])
                });
                $routeProvider.when('/rawDownload/:token', {
                    template: html_rawDownloadPage,
                    resolve: resolver(['testSettings/controllers/RawDownloadPageController'])
                });
                $routeProvider.when('/recollect/:testGuid', {
                    template: html_recollectPage,
                    resolve: resolver(['activation/controllers/RecollectPageController'])
                });
                $routeProvider.when('/ethnicity/:testGuid', {
                    redirectTo: function () {
                        return '/insights';
                    }
                });
                $routeProvider.when('/ethnicity/:testGuid/share/:shareToken1/:shareToken2', {
                    redirectTo: function () {
                        return '/insights';
                    }
                });
                $routeProvider.when('/matches/:testGuid', {
                    template: html_matchesPage,
                    resolve: resolver(['matches/controllers/MatchesPageController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/tests/:testGuid/match/:matchTestGuid/:cadId?', {
                    template: html_memberMatchPage,
                    resolve: resolver(['memberMatch/controllers/MemberMatchPageController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/tests/:testGuid/compare/:matchTestGuid', {
                    template: html_memberMatchPage,
                    resolve: resolver(['memberMatch/controllers/MemberMatchPageController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/tests/:testGuid/matches/:matchId', {
                    redirectTo: '/matches/:testGuid'
                });
                $routeProvider.when('/institution', {
                    template: html_instituteActivationPage,
                    resolve: resolver(['activation/controllers/InstitutionActivationPageController'])
                });
                $routeProvider.when('/tnc', {
                    template: html_tncPage,
                    resolve: resolver(['core/controllers/TncController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/tests/:testGuid/matchGone', {
                    template: html_matchGone,
                    resolve: resolver(['memberMatch/controllers/MatchGoneController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/newAncestors/:testGuid', {
                    template: html_showAll,
                    resolve: resolver(['showAll/controllers/ShowAllController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/circles/:testGuid', {
                    template: html_showAll,
                    resolve: resolver(['showAll/controllers/ShowAllController']),
                    reloadOnSearch: false
                });
                $routeProvider.when('/unsubscribe', {
                    template: html_unSubscribe,
                    resolve: resolver(['core/controllers/UnsubscribeController'])
                });
                $routeProvider.when('/viewConsole', {
                    template: html_legacyPage,
                    resolve: resolver(['tests/controllers/LegacyPageController'])
                });
                $routeProvider.when('/smgf', {
                    template: html_smgf,
                    resolve: resolver(['smgf/controllers/SmgfController'])
                });
                $routeProvider.when('/tests/:testGuid/roles/:inviteCode/accept', {
                    template: html_invitations,
                    resolve: resolver(['invitations/controllers/InvitationController'])
                });
                $routeProvider.when('/cms/:spotName', {
                    template: html_cmsPage,
                    resolve: resolver(['core/controllers/CmsPageController'])
                });
                $routeProvider.when('/subscribe/:testGuid?', {
                	template: html_subscribe,
                	resolve: resolver(['subscribe/controllers/SubscribePageController'])
                });
                $routeProvider.when('/newMatches', {
                	template: html_engagement,
                	resolve: resolver(['engagement/controllers/EngagementPageController'])
                });
                $routeProvider.when('/siteMaintenance', {
                    template: html_siteMaintenance
                });
                $routeProvider.when('/origins/:testGuid?', {
                    template: html_externalRedirect,
                    resolve: resolver(['core/controllers/ExternalRedirectController'])
                });
                $routeProvider.when('/activate', {
                    template: html_externalRedirect,
                    resolve: resolver(['core/controllers/ExternalRedirectController'])
                });

                $routeProvider.otherwise({
                    redirectTo: '/404',
                    template: html_error404,
                    resolve: resolver(['core/controllers/ErrorController'])
                });

                var params = getParams();
                $logProvider.debugEnabled(params.debug || params.develop || params.logDebug);

                $httpProvider.interceptors.push('TimingInterceptor');
                $httpProvider.interceptors.push('RetryInterceptor');
                $httpProvider.interceptors.push('RedirectInterceptor');
                $httpProvider.interceptors.push('LazyLoadImageRefreshInterceptor');

                $sceDelegateProvider.resourceUrlWhitelist([
                    // Allow same origin resource loads.
                    'self',
                    dna.app.baseUrl + '/**',
                    // Allow loading from ssl domain
                    dna.app.baseUrlSsl + '/**',
                    dna.app.cdnUrl.replace('/dna/main', '') + '/**',
                    'https://www.youtube.com/**'
                ]);
                dnaApp.hasHashInUrl = location.hash;

            }]).run(['$rootScope', '$filter', '$location', '$compile', '$window', '$http', 'ConfigurationService', 'TrackingService', 'MixpanelService', 'RetryInterceptor', 'UtilService', '$timeout', 'PerformanceMetric', '$exceptionHandler', 'TestsService',
            function($rootScope, $filter, $location, $compile, $window, $http, ConfigurationService, TrackingService, MixpanelService, RetryInterceptor, UtilService, $timeout, PerformanceMetric, $exceptionHandler, TestsService) {

                if (dnaApp.hasHashInUrl) {
                    $rootScope.insightsReady = true;
                }
                
                UtilService.setPageInfo('core', null);
                MixpanelService.load();

                $rootScope.$watch(function() {
                    return $http.pendingRequests.length;
                }, function(value) {
                    if (value === 0) {
                        $rootScope.$broadcast("httpComplete");
                    }
                });

                $rootScope.$on("$locationChangeStart", function(event) {
                    if (dna.app.showingSimpleHeader) {
                        dnaShowNormalHeader();
                    }
                });

                $rootScope.dna = dna;
                $rootScope.Cookies = Cookies;
                $rootScope.newLoginPath = false;
                $rootScope.errorViewTemplate = '';
                $rootScope.constants = {
                    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
                    SERVICE_UNAVAILABLE_CODE: 503
                };
                $rootScope.configSettings = ConfigurationService.configSettings;

                if (dnaApp.hasHashInUrl) {
                    $exceptionHandler("URL has hash", dnaApp.hasHashInUrl);
                }

                $rootScope.redirectTo = function(url) {
                    $location.url(url);
                };
                $rootScope.getView = function(moduleName, viewName) {
                    return dna.app.resourcesUrl + '/' + moduleName + '/partials/' + viewName;
                };
                $rootScope.getTemplate = function(templatePath) {
                    return dna.app.resourcesUrl + '/' + templatePath;
                };

                $rootScope.resetErrorBannerFlags = function() {
                    $rootScope.showServerErrorsBanner = false;
                    $rootScope.hideErrorBannerUntilRouteChange = false;
                };
                $rootScope.resetErrorBannerFlags();

                $rootScope.displayServiceErrorsBanner = function() {
                    $rootScope.showServerErrorsBanner = true;
                };

                $rootScope.hideErrorsUntilRouteChange = function() {
                    $rootScope.hideErrorBannerUntilRouteChange = true;
                };
                var errorMsgScope = $rootScope.$new();

                $rootScope.displayServiceUnavailableError = function(element, customErrorHtml) {
                    var compiledErrorDiv = $compile(html_error503_defaultDirectiveContent)(errorMsgScope);
                    $rootScope.displayServiceErrorsBanner();
                    var errorHtml = customErrorHtml || compiledErrorDiv;
                    element.html(errorHtml).show();
                    $compile(element.contents())(errorMsgScope);
                };

                $rootScope.refreshNextRoute = false;
                $rootScope.cameFromOrigins = document.referrer.indexOf('/dna/origins/') > -1;

                // Set cookies with parameters to help with development and debug (especially on mobile where cookies are harder to set)
                var urlParams = getParams();
                if (urlParams.set_dna_config) {
                    var createCookie,
                        setConfigs = urlParams.set_dna_config.split(',');
                    try {
                        createCookie = $rootScope.Cookies.find('dnaConfigSettings') ? JSON.parse($rootScope.Cookies.find('dnaConfigSettings')) : {};
                    } catch (e) {
                        createCookie = {};
                    }
                    setConfigs.forEach(function (item) {
                        var setConfig = item.split(':');
                        if (setConfig[1] === 'null') {
                            delete createCookie[setConfig[0]];
                            console.log('removed from config', setConfig[0]);
                        } else {
                            createCookie[setConfig[0]] = setConfig[1] === 'true';
                        }
                    });
                    
                    $rootScope.Cookies.create('dnaConfigSettings', JSON.stringify(createCookie));
                    console.log('Set Config Override Cookie', createCookie);
                }
                if (urlParams.asset_version_override) {
                    if (urlParams.asset_version_override !== 'null') {
                        $rootScope.Cookies.create('dnaAssetOverride', urlParams.asset_version_override);
                        console.log('set Asset Override Cookie', urlParams.asset_version_override);
                    } else {
                        $rootScope.Cookies.remove('dnaAssetOverride');
                        document.cookie = 'dnaAssetOverride=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + window.location.hostname.replace(/\w*.a/, '.a');
                        console.log('removed Asset Override Cookie');
                    }
                }
                if (urlParams.set_dna_debug_cookie) {
                    var setDebugConfigs = urlParams.set_dna_debug_cookie.split(',');
                    setDebugConfigs.forEach(function (item) {
                        var setConfig = item.split(/:(.+)/); // only split on first occurrence so cookie value can contain ':'
                        if (setConfig[1] === 'null') {
                            // this cookie is hard to kill with JS - Set it to null and the load balancer will ignore
                            $rootScope.Cookies.create(setConfig[0], 'null');
                            // Still try to remove the cookie
                            $rootScope.Cookies.remove(setConfig[0]);
                            console.log(setConfig[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + window.location.hostname.replace(/\w*.a/, '.a'));
                            document.cookie = setConfig[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + window.location.hostname.replace(/\w*.a/, '.a');
                            console.log('debug cookie removed', setConfig[0]);
                        } else {
                            $rootScope.Cookies.create(setConfig[0], setConfig[1]);
                            console.log('debug cookie created', setConfig[0]);
                        }
                    });
                }
                if (urlParams.clear_all_dna_overrides) {
                    $rootScope.Cookies.remove('dnaAssetOverride');
                    $rootScope.Cookies.remove('dnaConfigSettings');
                    // local dev & stage don't remove cookies with the built in plugin. So, these lines make sure the cookie is removed for the correct domain
                    document.cookie = 'dnaAssetOverride=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + window.location.hostname.replace(/\w*.a/, '.a');
                    document.cookie = 'dnaConfigSettings=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + window.location.hostname.replace(/\w*.a/, '.a');
                    console.log('removed asset and config cookies');
                }

                $rootScope.$on('$routeChangeStart', function ($event, next, current) {

                    RetryInterceptor.cancelAll();

                    $rootScope.resetErrorBannerFlags();

                    if ($rootScope.intro && next.$$route && next.$$route.controller !== 'MatchesPageController') {
                        $rootScope.keepIntro = true;
                        $rootScope.intro.exit();
                        $rootScope.keepIntro = false;
                    }

                    TestsService.getTestByTestGuid(next.params.testGuid).then(function (data) {
                        if (next.$$route && ['/matches/:testGuid', '/tests/:testGuid/match/:matchTestGuid/:cadId?'].indexOf(next.$$route.originalPath) >= 0 && data.productId === 3 && !$rootScope.dna.app.hasSub) {
                            if (data.role && data.role !== 'Subject') {
                                $location.path('/insights/' + data.guid);
                            } else {
                                $location.path('/subscribe/' + data.guid);
                            }
                        }
                    });

                    // reset the cameFromOrigins if the user visits the DNA LIHP
                    if (next.$$route && next.$$route.originalPath && next.$$route.originalPath.indexOf('/insights/') > -1) {
                        $rootScope.cameFromOrigins = false;
                    }

                    // Get Configuration Settings
                    ConfigurationService.getConfigurationSettings().then(function (configSettings) {
                        var isAssetOverrideSet = $rootScope.Cookies.find('dnaAssetOverride');
                        if (dna.app.assetsVersion && configSettings.assetsVersion && (configSettings.assetsVersion != dna.app.assetsVersion) && !isAssetOverrideSet) {
                            $rootScope.refreshNextRoute = true;
                        }
                    }, function () {
                        $rootScope.showServerErrorsBanner = true;
                    });

                    // don't execute on first load when global widgets are loading deferred/async
                    if (window.$ && $.modal && $rootScope.closeModal) {
                        $rootScope.closeModal();
                        $rootScope.closeCallout();
                    }
                });

                $rootScope.$on('$locationChangeStart', function (event, next, current) {
                    if ($rootScope.refreshNextRoute) {
                        event.preventDefault();
                        window.location.replace(next);
                    }
                });

                var lastUrl = '/';

                $rootScope.$on('$routeChangeSuccess', function($event, next, current) {
                    $('html').trigger('dna:routeChangeSuccess');
                    lastUrl = $location.url();
                    if (lastUrl === '') {
                        $location.url('/insights');
                    }
                    window.scrollTo(0, 0);
                });

                $rootScope.closeModal = function() {
                    $.modal.close();
                };

                $rootScope.closeCallout = function() {
                    $.callout.close();
                };
            }
        ]);
        return dnaApp;
    });

    require(['dnaApp'], function(dnaApp) {
        $(document).ready(function() {
            var $html = $('html');
            $html.attr('data-ng-app', 'dnaApp');
            $html.addClass('ng-app:dnaApp');
            $html.attr('id', 'ng-app');

            angular.bootstrap($html, ['dnaApp']);
        });
    }, function(err) {
        angular.injector(['ng']).invoke(['$log', function($log) {
            $log.error('Failed to load: ', err.requireModules, err.message, err.originalError);
        }]);
    });
}, function (err) {
    angular.injector(['ng']).invoke(['$log', function($log) {
        if (err && err.requireModules) {
            for (var i = 0; i < err.requireModules.length; i++) {
                var errFile = err.requireModules[i];
                $log.error('Unable to load ' + errFile + ' file. (' + require.s.contexts._.config.paths[errFile] + ')', err);
            }
        } else {
            $log.error('Unknown RequireJS error.', err);
        }
    }]);
});

define("app", function(){});

